export default [
  { label: "Feminino", value: "FEMININO" },
  { label: "Masculino", value: "MASCULINO" },
];
